export type IDictionary<TValue> = {
  [key: string]: TValue;
};

export type PartialProduct = {
  id: string;
  price: number;
  date_created: Date;
  modified_at: Date;
  name: string;
  description: string;
  stock: number;
  accepted_payment_methods: IDictionary<IPartialProductValue>;
  payment_method_pretty_names: IDictionary<string>;
  metadata: IDictionary<object>;
  has_promo: boolean;
  is_temporary: boolean;
  creator_id: string;
  woocommerce_order_id: number | undefined;
};

export type PaymentInfo = {
  type: string;
  status: string;
  confirm_url: string;
  email: string;
  user_name: string;
  payment_method?: string;
};

export interface IPartialProductValue {
  accepted_cryptos?: string[];
  price?: number;
  api_key?: string;
}

export interface SelectData {
  value: string;
  text: string;
};

export async function getCountry(countryCode?: string): Promise<boolean> {
  const req =
    countryCode !== undefined
      ? `/api/location/hasPostal?countryCode=${countryCode}`
      : "/api/location/hasPostal";
      
  const resp = await fetch(req);

  if (resp.status >= 400) return false;

  return resp.ok;
}

export async function getProduct(
  id: string | undefined
): Promise<PartialProduct | undefined> {
  if (id === undefined) return undefined;

  const resp = await fetch(`/api/product/${id}`);

  if (resp.status >= 400) return undefined;

  return (await resp.json()) as PartialProduct;
}
